module.exports = __webpack_public_path__ + "images/application/stats-empty-opens-a8fd6ef8.jpg";